import { intercomConversationUrl } from 'constants/admin-note-templates';

import { StatusPill } from 'components/Pills/StatusPills';

import { useGetIntercomConversationsQuery } from 'api/intercom-conversations-api';

export const CheckActivity = ({ candidateId, check, subCheck = null }) => {
  const { data: conversations = [] } = useGetIntercomConversationsQuery(candidateId, {
    skip: !candidateId,
  });

  const linked = (conversations || []).filter(
    conversation =>
      conversation.open &&
      (conversation.links || []).some(link => {
        if (subCheck) return Number(link.sub_check_id) === Number(subCheck.id);
        return Number(link.candidate_check_id) === Number(check?.id);
      }),
  );

  const source = subCheck || check;
  const documentCount = Number(source?.open_document_request_count || 0);
  const intercomCount = Number(source?.open_intercom_count || 0);

  if (!documentCount && !intercomCount && !linked.length) return null;

  return (
    <div className="d-flex flex-column u-gap-small u-margin-bottom">
      <span className="t-tiny u-semi-bold u-uppercase secondary-text">Activity</span>
      <div className="d-flex flex-wrap u-gap-small">
        {documentCount > 0 && (
          <StatusPill text={`${documentCount} open document request`} status="warning" />
        )}
        {intercomCount > 0 && (
          <StatusPill text={`${intercomCount} open Intercom`} status="continue" />
        )}
      </div>
      {linked.map(conversation => {
        const url = intercomConversationUrl(conversation.intercom_id);
        return (
          <a
            key={conversation.id}
            href={url || undefined}
            target="_blank"
            rel="noreferrer"
            className="u-font-size-small">
            Intercom {conversation.intercom_id}
          </a>
        );
      })}
    </div>
  );
};
